import { cn } from "@/lib/utils"
import { APCMState, STATE_COLORS, type StateColor } from "../types/apcm-ops.types"

const colorClasses: Record<StateColor, string> = {
  emerald: "bg-success/10 text-success ring-success/30",
  blue: "bg-info/10 text-info ring-info/30",
  amber: "bg-warning/10 text-warning ring-warning/30",
  red: "bg-destructive/10 text-destructive ring-destructive/30",
  gray: "bg-muted/50 text-muted-foreground ring-border",
}

const dotColors: Record<StateColor, string> = {
  emerald: "bg-success",
  blue: "bg-info",
  amber: "bg-warning",
  red: "bg-destructive",
  gray: "bg-muted-foreground/40",
}

function formatStateName(state: string): string {
  return state
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase())
}

interface APCMStateBadgeProps {
  state: string
  className?: string
}

export function APCMStateBadge({ state, className }: APCMStateBadgeProps) {
  const color = STATE_COLORS[state as APCMState] || "gray"

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-md ring-1 ring-inset px-2 py-0.5 text-[11px] font-medium",
        colorClasses[color],
        className
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", dotColors[color])} />
      {formatStateName(state)}
    </span>
  )
}
